import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/hetong-wenshu', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-quill-pen-line text-background-50 text-lg"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-900 whitespace-nowrap">
              一起草
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to ||
                  (link.to.startsWith('/category') && location.pathname.startsWith('/category'))
                    ? 'text-primary-600'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              免费试用
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap"
            >
              立即开始
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 mt-0">
            <div className="flex flex-col gap-3 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex gap-3 pt-2">
                <Link
                  to="/about"
                  className="flex-1 text-center px-4 py-2.5 text-sm font-medium text-foreground-700 border border-background-300 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  免费试用
                </Link>
                <Link
                  to="/about"
                  className="flex-1 text-center px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  立即开始
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}